<template>
    <div v-if="$store.state.readyState" class="launch">
        <div class="wrapper">
            <div v-if="launchReady" class="launch__hero">
                <div class="launch__hero-card">
                    <h2 class="launch__title">{{launch.mission_name}}</h2>
                    <div class="launch__hero-date">
                        <img src="../assets/calendar.svg" alt="">
                        <span>{{convertTimestamp(launch.launch_date_unix)}}</span>
                    </div><!-- /.launch__hero-icon -->
                    <div v-if="mission" class="launch__hero-date">
                        <span>Mission: {{mission.mission_name}}</span>
                    </div><!-- /.launch__hero-icon -->
                    <p>{{launch.details}}</p>
                    <div class="launch__hero-icons">
                        <router-link :to="{name: 'rocket', params: { id: launch.rocket.rocket_id}}" class="launch__hero-icon">
                            <img src="../assets/spaceship.svg" alt="">
                            <span>{{launch.rocket.rocket_name}}</span>
                        </router-link><!-- /.card__title -->
                        <a target="_blank" :href="launch.links.video_link" class="launch__hero-icon">
                            <img src="../assets/youtube.svg" alt="">
                            <span>Watch the video</span>
                        </a><!-- /.launch__hero-icon -->
                        <a target="_blank" :href="launch.links.presskit" class="launch__hero-icon">
                            <img src="../assets/press.svg" alt="">
                            <span>PressKit</span>
                        </a><!-- /.launch__hero-icon -->
                        <a target="_blank" :href="launch.links.wikipedia" class="launch__hero-icon">
                            <img src="../assets/world.svg" alt="">
                            <span>Wikipedia</span>
                        </a><!-- /.launch__hero-icon -->
                    </div><!-- /.launch__hero-icons -->
                </div><!-- /.misson__hero-card -->
                <div class="launch__hero-image">
                    <img :src="launch.links.flickr_images[0]" class="img--bg" alt="">
                </div><!-- /.launch__hero-image -->
            </div><!-- /.misson__hero -->
            <div class="launch__video">
                <iframe v-if="launch.flight_number" :src="`https://www.youtube.com/embed/${launch.links.youtube_id}?wmode=transparent`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div><!-- /.launch__video -->
            <div v-if="launchReady" class="image-grid">
                <div v-for="(image, index) in launch.links.flickr_images" :key="index" class="image-grid__image">
                    <img :src="'https://img.gs/rkbzmnfzcp/500x500,crop=auto,quality=low/' + image" class="img img--bg" v-on:load="imageLoaded($event)" alt="">
                </div><!-- /.image-grid__image -->    
            </div><!-- /.image-grid -->
        </div><!-- /.wrapper -->
    </div><!-- /.launch -->
</template>

<script>
import objectFitImages from 'object-fit-images'
export default {
    name: 'Launch',
    components: {

    },
    data() {
        return {
            id: 0,
            launch: false,
            apiUrl: 'https://api.spacexdata.com/v3/launches/?launch_success=true',
            launchReady: false,
            mission: null
        }
    },
    created() {
        
    },
    methods: {
        convertTimestamp(timestamp) {
            parseInt(timestamp);
            var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
            yyyy = d.getFullYear(),
            mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
            dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
            hh = d.getHours(),
            h = hh,
            min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
            ampm = 'AM',
            time;
                    
            if (hh > 12) {
                h = hh - 12;
                ampm = 'PM';
            } else if (hh === 12) {
                h = 12;
                ampm = 'PM';
            } else if (hh == 0) {
                h = 12;
            }
            
            // ie: 2013-02-18, 8:35 AM	
            time = dd + '-' + mm + '-' + yyyy + ', ' + h + ':' + min + ' ' + ampm;
                
            return time;
        },
        imageLoaded(e) {
            objectFitImages('.img--bg');
            $('.img--bg').addClass('loaded');
            console.log('loaded');
            console.log(e);
            
            
        }
    },
    mounted() {
        this.id = parseInt(this.$route.params.id);
        this.launch = this.$route.params.launch ? this.$route.params.launch : null
        this.mission = this.$route.params.mission ? this.$route.params.mission : null
        if(this.mission == null || this.launch == null) {
            this.launch = this.$store.state.launches.filter((i) => { 
                return i.flight_number === this.id                
            })[0];
            this.mission = this.$store.state.missions.filter(i => i.mission_id === this.launch.mission_id[0])[0];
            console.log('in');
            
        }
        this.launchReady = true;
        let windowHeight = window.innerHeight;
        if($('#app').innerHeight() > windowHeight) {
            $(window).scrollTo(0);
        }
        // var loaded = () => {
        //     objectFitImages('.img--bg');
        // }
        // var img = document.getElementsByClassName('img--bg')
        // img[0].addEventListener('load', loaded);
    },
}
</script>

<style>

</style>
